.kioskToggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.45);
  background: rgba(255, 255, 255, 0.32);
  backdrop-filter: blur(14px) saturate(140%);
  -webkit-backdrop-filter: blur(14px) saturate(140%);
  color: var(--token-text-primary);
  cursor: pointer;
  transition:
    background 120ms ease,
    transform 120ms ease,
    color 120ms ease;
  box-shadow:
    0 10px 24px -10px rgba(0, 0, 0, 0.45),
    inset 0 1px 0 rgba(255, 255, 255, 0.55);
}

.kioskToggle:hover {
  background: rgba(255, 255, 255, 0.55);
  transform: translateY(-1px);
}

.kioskToggle:active {
  transform: translateY(0);
}

.kioskToggle[aria-pressed='true'] {
  background: var(--token-accent);
  color: #fefdf6;
  border-color: rgba(255, 255, 255, 0.45);
}
